import { OnboardingStep } from 'types/onboardingTypes'

export function getBMIInfo(): OnboardingStep {
  return {
    id: 'bmi_info',
    type: 'custom',
  }
}
